import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import * as contact from './my-connections.actions';
import { HttpService } from '../../../global/http.service';

@Injectable()
export class MyConnectionsEffects {
    public loadMyConnections$ = createEffect(() => this.actions$.pipe(
        ofType<contact.LoadConnectionsAction>(contact.ActionTypes.LOAD_CONNECTIONS),
        switchMap(() =>
            this.loadMyConnections().pipe(
                map(response =>
                    new contact.LoadConnectionsSuccessAction(response)
                ),
                catchError(error =>
                (from([
                    new contact.LoadConnectionsFailedAction(error)
                ])
                ))
            )
        )
    ));

    public constructor(
        private readonly actions$: Actions,
        private readonly http: HttpService,
    ) {
    }

    private loadMyConnections(): Observable<any> {

        return this.http.get(`/clients/myconnection`);
    }
}
